import { createBrowserRouter, Navigate } from 'react-router-dom';

import AppLayout from '@/layouts/AppLayout';
import DashboardPage from '@/pages/DashboardPage';
import IndustrialRefBookPage from '@/pages/IndustrialRefBookPage';
import NotFoundPage from '@/pages/NotFoundPage';
import StatsPage from '@/pages/StatsPage';
import WorkspacePanel from '@/components/workspace/WorkspacePanel';
import { PANEL_MODE_PATH, readLastPanelMode } from '@/utils/panelMode';

import { ROUTES } from './paths';

/**
 * Index landing component — redirects `/` to the user's last panel mode
 * (Routes by default). Kept as a component so `readLastPanelMode()` is
 * called per navigation rather than once at module load, which keeps
 * the redirect in sync with any same-session preference bumps.
 */
function LastModeRedirect() {
  const target = PANEL_MODE_PATH[readLastPanelMode()];
  return <Navigate to={target} replace />;
}

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <LastModeRedirect /> },
      { path: ROUTES.ROUTES, element: <WorkspacePanel mode="routes" /> },
      { path: ROUTES.BARRIERS, element: <WorkspacePanel mode="barriers" /> },
      { path: ROUTES.DASHBOARD, element: <DashboardPage /> },
      { path: ROUTES.STATS, element: <StatsPage /> },
      { path: ROUTES.INDUSTRIAL_REF_BOOK, element: <IndustrialRefBookPage /> },
      { path: ROUTES.NOT_FOUND, element: <NotFoundPage /> },
    ],
  },
  { path: '*', element: <Navigate to={ROUTES.NOT_FOUND} replace /> },
]);
